module.exports = __webpack_public_path__ + "b0d39e8d2486d5da74c83834c847adac.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/img1.jpg
// module id = 285
// module chunks = 0